// Board column colors, shared by Edit Columns (EditColumnsPanel.vue) and meeting templates (MeetingTemplates.vue).

// A new column starts out Light Gray
export const NEW_COLUMN_COLOR = '#D4D4D4';

// Apply Default Colors: palette colors (store colorPalette) by label, assigned from the last column backwards. The last
// column is taken to be Done (green), the one before it in progress (orange), and so on. Past eight columns the list
// starts over.
const DEFAULT_COLUMN_COLORS = [ 'Green', 'Orange', 'Blue', 'Purple', 'Teal', 'Rose', 'Gold', 'Gray' ];

// Recolors the columns ({ color }) in place
export function applyDefaultColumnColors(columns: any[], palette: { label: string, hex: string }[]) {
    const colors = DEFAULT_COLUMN_COLORS.map(label => palette.find(c => c.label == label)?.hex).filter(hex => hex) as string[];
    columns.forEach((col, i) => {
        col.color = colors[(columns.length - 1 - i) % colors.length];
    });
}
